import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { titles, white } from '../../../styles/colors';

const { spacing } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: spacing.lg,
	},

	infoHeaderContentBold: {
		marginTop: spacing.xs,
		marginBottom: spacing.md,
		fontWeight: 600,
	},
	loadingRow: {
		height: 300,
	},
	viewOnlyModeBannerContent: {
		display: 'flex',
		fontSize: 14,
		padding: `${spacing.lg}px ${spacing.lg}px ${spacing.lg}px ${spacing.xxxl}px`,
		gap: 8,
	},
	viewOnlyModeBannerContainer: {
		justifyContent: 'space-between',
		display: 'flex',
		background: '#FFEDF9',
		borderLeft: '3px solid #78DBFF',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: titles,
		alignItems: 'flex-start',
		marginBottom: spacing.md,
	},
	drawerContainer: {
		backgroundColor: white,
		height: '100%',
		padding: `${spacing.md}px ${spacing.lg}px`,
		width: '100%',
	},
	dataBoardContainer: {
		backgroundColor: 'transparent',
	},
	drawerSection: {
		paddingRight: spacing.md,
	},
	sectionTitle: {
		color: titles,
		fontSize: 14,
		margin: '20px 0 5px 0',
	},
});
